import axios from 'axios'
import constant from '../js/constant'
import Encoding from 'encoding-japanese';
import BigNumber from 'bignumber.js'
import user from '../store/user.js';

function createNumArray(item) {
    item.numArray = []
    item.unit = 2
    const min = 2
    for (let i = min; i <= item.maxUnit; i++) {
        item.numArray.push(i)
    }

    item.unitFlg = true
}

//ストアへの値保存
function setStore(obj, name, data) {
    obj.$store.dispatch(name, data)
}

//ストアから値の取得
function getStore(obj, name) {
    return obj.$store.getters[name]
}

//ルータへの遷移先セット
function setRoute(obj, path) {

    //エラー発生時の場合は画面遷移時のアニメーション用のCSSを適用しない
    if (!obj.errorFlg()) {
        //遷移元の画面に画面遷移時のアニメーションのCSSを充てる(次へと戻るで異なるCSSを充てる)
        if (obj.$options.parent.isBack) {
            obj.setShowClass(constant.HIDE_PREV)
        } else {
            obj.setShowClass(constant.HIDE_NEXT)
        }
        setscrollTop()
    }

    setTimeout(function () {
        //routerで遷移を制御する場合、エラーとなるためcatchが必要
        obj.$router.push(path).catch(() => { console.log() })
    }, 500);
}

// 和暦名を付与
function getEraName(year) {
    let yearLastDate = year.toString() + '/12/31'
    return new Date(yearLastDate).toLocaleDateString("ja-JP-u-ca-japanese", { era: "short", year: "numeric" })
}

//全角カナのみチェック
function isZenkakuKana(str) {
    return !str.match(/[^ァ-ヶー]+$/)
}

//半角数字のみチェック
function isHankakuNum(str) {
    return str.match(/^[0-9]+$/)
}

//小数チェック
function isSyousuNum(num) {
    return !Number.isInteger(num)
}

//電話番号桁数チェック
function isTelMaxLength(str) {
    return str.length == 10 || str.length == 11
}

// メールアドレスフォーマットチェック
function isMailAddress(mailAddress) {
    const regExp = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
    return regExp.test(mailAddress)
}

//有効日付チェック
function isEnableDate(year, month, day) {
    let date = new Date(year, month - 1, day)
    return date.getMonth() + 1 == month
}

//Sjis対応文字チェック
function isSjis(str) {
    //変換できない場合に"?"になるため、Sjis変換前後の"?"の数から変換可能かどうかを判断する。

    //"?"の数をカウント
    let count = (str.match(/\?/g) || []).length

    // 文字列を配列に変換
    let ArrStr = str.split('').map((v) => v.charCodeAt());

    //Sjisに変換
    let actual;
    actual = Encoding.convert(ArrStr, {
        to: 'SJIS',
        from: 'UNICODE'
    });

    //UNICODE配列に戻す
    let actualStr = Encoding.convert(actual, 'UNICODE');

    //配列⇒文字に変換
    let str2 = Encoding.codeToString(actualStr);
    //"?"の数をカウント
    let countSjis = (str2.match(/\?/g) || []).length;

    //"?"の数を比較
    if (count != countSjis) {
        return false
    } else {
        return true
    }
}

// 禁止文字チェック
function isDisallowStr(str) {
    const strReg = new RegExp(`[${constant.DISALLOW_STRINGS.join('')}]`, 'g')
    return strReg.test(str);
}

// 入力欄に文字チェック
function checkStr(str) {
    return isSjis(str) && !isDisallowStr(str)
}

//axios実行(GET)
async function executeAxiosGet(url, func, obj) {

    obj.$options.parent.isLoading = true
    await axios.get(url)

        // thenで成功した場合の処理
        .then(async (response) => {

            if (typeof response.data.err_msg === "undefined") {
                await func(response)
            } else {
                alert(response.data.err_msg)
            }

            obj.$options.parent.isLoading = false
        })
        .catch(() => {
            alert(obj.$msg.ERROR.MSG_9997)
            obj.$options.parent.isLoading = false
        })


}

//axios実行(POST)
async function executeAxiosPost(url, func, params, obj) {

    obj.$options.parent.isLoading = true
    await axios.post(url, params)

        // thenで成功した場合の処理
        .then(async (response) => {
            if (typeof response.data.err_msg === "undefined") {
                await func(response)
            } else {
                alert(response.data.err_msg)
            }
            obj.$options.parent.isLoading = false
        })
        .catch((e) => {
            if (Object.keys(e.response.data).length > 0 && e.response.data.err_msg === "application ng") {
                obj.setErrorFlg(true)
                setscrollTop()
            } else {
                alert(obj.$msg.ERROR.MSG_9997)
            }
            obj.$options.parent.isLoading = false
        })

}

//戻るボタン押下で遷移したかどうかをセット
function setIsBack(obj, isBack) {
    obj.$options.parent.isBack = isBack
}

// スマホ判定
function isSmartPhone() {
    if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
        return true;
    } else {
        return false;
    }
}

//ヘッダ部のアクティブ表示切替
function headerActiveSwitching(obj) {
    if (typeof obj.$options.parent === "undefined") { return true }

    //ヘッダ部の画像のアクティブ表示を切り替え
    obj.$options.parent.isCollection = false
    if (location.pathname == constant.BASE_PATH + constant.ADDRESS_FORM_PATH
        || location.pathname == constant.BASE_PATH + constant.LARGE_ITEMS_PATH
        || location.pathname == constant.BASE_PATH + constant.MEDIUM_ITEMS_PATH
        || location.pathname == constant.BASE_PATH + constant.SMALL_ITEMS_PATH
        || location.pathname == constant.BASE_PATH + constant.SPECIFIC_DATETIME_PATH) {
        obj.$options.parent.isCollection = true
    }
    obj.$options.parent.isCustomer = location.pathname == constant.BASE_PATH + constant.CUSTOMER_INFORMATION_PATH ? true : false
    obj.$options.parent.isConfirm = location.pathname == constant.BASE_PATH + constant.CONFIRMATION_SCREEN_PATH ? true : false
    obj.$options.parent.isComplete = location.pathname == constant.BASE_PATH + constant.COMPLETE_PAGE_PATH ? true : false
}


// type=numberのmaxlength制御
function adjustMaxLength(obj, e) {
    if (obj.value.length > e.target.maxLength) {
        obj.value = obj.value.slice(0, e.target.maxLength)
    }
}

//スクロール位置をトップにする。
function setscrollTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}

//戻る押下時
function pageBack(obj, path) {
    obj.setErrorFlg(false)
    this.setStore(obj, 'errorFlg', obj.errorFlg())
    this.setIsBack(obj, true)
    this.setRoute(obj, path)
}

//null変換関数
function nvl(val1, val2) {
    return (val1 == null) ? val2 : val1;
}

// 税込金額
function includingTax(fee, taxRate) {
    return Math.round(Number(BigNumber(fee).times(BigNumber(1).plus(BigNumber(taxRate).div(100)))))
}

// ストアをリセット
function resetStore(obj) {
    for (let [key, value] of Object.entries(user.state)) {
        setStore(obj, key, value)
    }
}

// 選択した大型品目数をカウント
function countLargeItems(obj) {
    return getStore(obj, 'largeItems').reduce((pre, cur) => pre + cur.unit, 0)
}

// 選択した中型台数をカウント
function countMediumItems(obj) {
    return getStore(obj, 'mediumItems').reduce((pre, cur) => pre + cur.unit, 0)
        + (getStore(obj, 'addMediumItem').unit ?? 0)
}

// 表示品目を取得
function getItems(items, masterItems) {
    let result = []
    let smartPhone = isSmartPhone()
    items.forEach(item => {
        let matchItem = masterItems.find(
            masterItem => masterItem.ITEM === item.code
        )
        if (matchItem) {
            // 個別画像指定
            if (matchItem.IMAGE_FLG === "1") {
                item.image = smartPhone
                    ? matchItem.IMAGE_PATH_SP
                    : matchItem.IMAGE_PATH_PC
            }
            result.push(item)
        }
    })
    return result
}

// 「中型」表示品目数
function countMediumView(obj) {
    return getStore(obj, 'mediumItems').length + (Object.keys(getStore(obj, 'addMediumItem')).length ? 1 : 0)
}

// 「小型」表示品目数
function countSmallView(obj) {
    return Object.keys(getStore(obj, 'smallItems')).length ? 1 : 0
}

// 申込書表示判定
function isApplicationForm(obj) {
  if (typeof obj.$options.parent === "undefined") { return true }

  obj.$options.parent.isApplicationForm = location.pathname == constant.BASE_PATH + constant.DATA_ERASE_APPLICATION_FORM_PATH ? true : false
}

// 品目説明文表示
function displayItemDescription(obj, item) {
  let siteCodeItem = obj.siteCodeItem.find(x => x.ITEM == item.code)
  return siteCodeItem.length > 0 && isSmartPhone() ? siteCodeItem.ITEM_DESCRIPTION1_SP : siteCodeItem.ITEM_DESCRIPTION1_PC
}

// 契約書ダウンロード
async function contractDownload(obj, url, params, thanksPage) {
    obj.$options.parent.isLoading = true

    await axios.post(url, params, {responseType: 'blob'})

        // thenで成功した場合の処理
        .then(({data, status}) => {
            if (status == 200) {
                let now = new Date()

                let fileName = constant.CONTRACT_FILE_NAME
                                  .replace("YYYY", now.getFullYear())
                                  .replace("MM", now.getMonth() + 1)
                                  .replace("DD", now.getDate())
                                  .replace("HH", now.getHours())
                                  .replace("mm", now.getMinutes())
                                  
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", fileName); 
                document.body.appendChild(link);
                link.click();
                link.remove();

                if(thanksPage){
                    setStore(obj, 'downloadTarget', constant.CONTRACT_NAME)
                    setRoute(obj, constant.DOWNLOAD_COMPLETE_PAGE_PATH)
                }
            } else {
                alert(data.err_msg)
            }
            obj.$options.parent.isLoading = false
        })
        .catch(() => {
            alert(obj.$msg.ERROR.MSG_9997)
            obj.$options.parent.isLoading = false
        })
}


export default {
    constant,
    createNumArray,
    setStore,
    getStore,
    setRoute,
    getEraName,
    executeAxiosGet,
    executeAxiosPost,
    isSmartPhone,
    adjustMaxLength,
    headerActiveSwitching,
    isZenkakuKana,
    isHankakuNum,
    isSyousuNum,
    isTelMaxLength,
    isMailAddress,
    isEnableDate,
    isSjis,
    isDisallowStr,
    checkStr,
    setscrollTop,
    setIsBack,
    pageBack,
    nvl,
    includingTax,
    resetStore,
    countLargeItems,
    countMediumItems,
    getItems,
    countMediumView,
    countSmallView,
    isApplicationForm,
    displayItemDescription,
    contractDownload
}
